export const MAXIMUM_STRIPE_AMOUNT = 110000.0;
